__webpack_require__.p = "/reports-less-yaxis-lines/onboarding/";